import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { listCierres } from '../../services/data';
import { nombreTurno } from '../../utils/turnos';
import { formatTime } from '../../utils/dates';

const POR_PAGINA = 10;
const fechaCorta = (ymd) => (ymd ? String(ymd).slice(0, 10).split('-').reverse().join('/') : '—');

// Cuadres recientes de la sucursal (la API limita al cajero a su sucursal y a los últimos 30 días),
// los haya registrado él u otro cajero. Ver detalle siempre; Corregir solo si Administración lo habilitó.
export default function CuadresRecientes() {
  const navigate = useNavigate();
  const [estado, setEstado] = useState({ cargando: true, lista: [], error: '' });
  const [pagina, setPagina] = useState(1);
  useEffect(() => {
    let vivo = true;
    listCierres({})
      .then((lista) => { if (vivo) setEstado({ cargando: false, lista, error: '' }); })
      .catch((e) => { if (vivo) setEstado({ cargando: false, lista: [], error: e.message || 'No se pudieron cargar los cuadres' }); });
    return () => { vivo = false; };
  }, []);

  const paginas = Math.max(1, Math.ceil(estado.lista.length / POR_PAGINA));
  const visibles = estado.lista.slice((pagina - 1) * POR_PAGINA, pagina * POR_PAGINA);
  const ir = (c, ver) => navigate(`/Finanzas/RegistrarCierre?id=${encodeURIComponent(c.id)}${ver ? '&mode=view' : ''}`);
  return (
    <section className="ct-card ct-recientes" aria-labelledby="ct-recientes-titulo">
      <div className="ct-card-head"><div><h2 id="ct-recientes-titulo">Cuadres recientes</h2><p className="ct-muted">Últimos 30 días</p></div></div>
      {estado.cargando ? <p className="ct-muted">Cargando…</p>
        : estado.error ? <p className="ct-muted" role="alert">{estado.error}</p>
        : !estado.lista.length ? <p className="ct-muted">No hay cuadres en los últimos 30 días.</p>
        : <table className="ct-tabla ct-tabla--recientes">
          <thead><tr><th>Fecha</th><th>Turno</th><th>Realizado por</th><th>Estado</th><th>Acciones</th></tr></thead>
          <tbody>{visibles.map((c) => {
            const corregible = c.estado === 'Corrección';
            return (
              <tr key={c.id}>
                <td data-label="Fecha">{fechaCorta(c.fecha)}{c.cierreAt && <small className="ct-muted ct-recientes-hora">{formatTime(c.cierreAt)}</small>}</td>
                <td data-label="Turno">{nombreTurno(c.turnoId)}</td>
                <td data-label="Realizado por">{c.username || '—'}</td>
                <td data-label="Estado"><span className={`ct-estado${corregible ? ' ct-estado--correccion' : ''}`}>{corregible ? 'Corrección habilitada' : 'Cerrado'}</span></td>
                <td data-label="Acciones" className="ct-recientes-acciones">
                  <button type="button" className="ct-link" onClick={() => ir(c, true)}>Ver detalle</button>
                  {corregible && <button type="button" className="ct-btn ct-btn--primary" onClick={() => ir(c, false)}>Corregir</button>}
                </td>
              </tr>);
          })}</tbody>
        </table>}
      {paginas > 1 && <nav className="ct-recientes-paginas" aria-label="Paginación">
        <button type="button" className="ct-btn" disabled={pagina <= 1} onClick={() => setPagina((p) => p - 1)}>Anterior</button>
        <span>Página {pagina} de {paginas}</span>
        <button type="button" className="ct-btn" disabled={pagina >= paginas} onClick={() => setPagina((p) => p + 1)}>Siguiente</button>
      </nav>}
    </section>
  );
}
